import {
    FaCircleDot,
    FaCircleXmark,
    FaCircleDown,
    FaCircleExclamation,
    FaTriangleExclamation,
} from 'react-icons/fa6'
import { ChatStatus } from '~graphql/generated/graphql'

export const CHAT_STATUS_ICONS = {
    [ChatStatus.Open]: FaCircleDot,
    [ChatStatus.Closed]: FaCircleXmark,
    [ChatStatus.HighPriority]: FaTriangleExclamation,
    [ChatStatus.NormalPriority]: FaCircleExclamation,
    [ChatStatus.LowPriority]: FaCircleDown,
}

export const CHAT_STATUS_COLORS = {
    [ChatStatus.Open]: 'brand',
    [ChatStatus.Closed]: 'gray',
    [ChatStatus.HighPriority]: 'red',
    [ChatStatus.NormalPriority]: 'yellow',
    [ChatStatus.LowPriority]: 'blue',
}
